import { apiGet } from '../../../adapters/api-client/api';

/** S5.5 — what a teacher can see about one of their own courses. */

export interface RosterEntry {
  enrollmentId: string;
  studentId: string;
  studentFirstName: string;
  studentGrade?: number;
  state: string;
  enrollmentDate: string;
  sessionsCompleted: number;
  sessionsTotal: number;
  nextSessionAt?: string;
  nextSessionSequence?: number;
}

export interface CourseRoster {
  courseId: string;
  title: string;
  status: string;
  subject: string;
  price: number;
  /** What the price is denominated in. */
  currency: string;
  /** Full description as authored. */
  description: string;
  /** ONGOING or FIXED. */
  durationMode: string;
  /** Present only when durationMode is FIXED. */
  durationWeeks?: number;
  /** Distinct children taught. Not seats: a checkout in flight holds a seat. */
  learners: number;
  /** 0–1, or null when nobody has taken the course. */
  completionRate: number | null;
  duration: number;
  offerMode: string;
  deliveryFormat: string;
  capacity: number;
  seatsTaken: number;
  students: RosterEntry[];
}

export function getCourseRoster(courseId: string): Promise<CourseRoster> {
  return apiGet(`/api/v1/courses/${courseId}/roster`);
}
